import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import api from "@/api/client";
import { useCart } from "@/context/CartContext";

export function PaymentSuccess() {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("session_id");
  const [status, setStatus] = useState("checking");
  const { clearCart } = useCart();

  useEffect(() => {
    if (!sessionId) {
      setStatus("error");
      return;
    }
    const check = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setStatus("paid");
          clearCart();
        } else {
          setTimeout(check, 2000);
        }
      } catch {
        setStatus("error");
      }
    };
    check();
  }, [sessionId]);

  return (
    <div className="flex min-h-screen items-center justify-center pt-[73px]">
      <div className="mx-4 w-full max-w-md border border-white/10 bg-surface p-8 text-center" data-testid="payment-success-page">
        {status === "checking" && (
          <>
            <div className="mx-auto h-12 w-12 animate-spin rounded-full border-2 border-volt border-t-transparent" />
            <h1 className="mt-6 font-display text-2xl font-bold uppercase text-white">Confirming Payment</h1>
            <p className="mt-2 font-mono text-sm text-slate-400">Please wait...</p>
          </>
        )}
        {status === "paid" && (
          <>
            <CheckCircle2 className="mx-auto h-16 w-16 text-volt" />
            <h1 className="mt-6 font-display text-3xl font-bold uppercase text-white" data-testid="payment-success-heading">Payment Complete</h1>
            <p className="mt-2 text-slate-400">Thank you for your order. A confirmation email is on its way, and we'll get your parts shipped out soon.</p>
            <Link to="/shop" className="mt-8 inline-block bg-volt px-8 py-3 font-mono text-sm font-bold uppercase text-obsidian hover:bg-white" data-testid="continue-shopping">
              Continue Shopping
            </Link>
          </>
        )}
        {status === "error" && (
          <>
            <h1 className="font-display text-2xl font-bold uppercase text-white" data-testid="payment-error-heading">Something went wrong</h1>
            <p className="mt-2 text-slate-400">We couldn't confirm your payment. Please contact support.</p>
            <Link to="/contact" className="mt-8 inline-block border border-white/30 px-8 py-3 font-mono text-sm uppercase text-white hover:border-volt hover:text-volt" data-testid="contact-support">
              Contact Support
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
